'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import SplideSlider from '@components/SplideSlider';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';

export default function WharfRiverside(props: any) {
  const wharfRiversideSlideStorySettings = {
    type: 'slide',
    rewind: false,
    speed: 2000,
    pagination: true,
    arrows: true,
    autoplay: true,
    interval: 6000,
  };

  const wharfRiversideSlideElement =
    props?.locale?.section?.ransomRiversideSlider ?? [];

  return (
    <Stack component="section" className={cn.wharfRiversideWrapper}>
      <Box className={cn.wharfRiversideInner}>
        <Box className={cn.wharfRiversideBlock}>
          <SplideSlider
            showArrows
            showPagination
            arrowsClassName={cn.wharfRiversideArrows}
            prevClassName={cn.riversideArrowsPrev}
            nextClassName={cn.riversideArrowsNext}
            paginationClassName={cn.wharfRiversidePagination}
            dotClassName={cn.riversidePaginationDots}
            activeDotClassName={cn.riversidePaginationActive}
            prevArrow={<ArrowLeftIcon />}
            nextArrow={<ArrowRightIcon />}
            options={wharfRiversideSlideStorySettings}
          >
            {wharfRiversideSlideElement.map((item: any, index: number) => (
              <Box key={item.url ?? index} className={cn.wharfRiversideStory}>
                <CustomImage
                  src={item.url}
                  alt={item.alt ?? `slider-image-${index}`}
                  width={1200}
                  height={800}
                />
              </Box>
            ))}
          </SplideSlider>
        </Box>
      </Box>
    </Stack>
  );
}
